var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from "react";
import "react-toggle/style.css";
import newId from "@irati/utils/id";
import HintText from "../../HintText";
import Load from "./../utils/Load";
import Flex from "../../Flex";
import { perkbox } from "../../global/colors";
import { StyledLabel, StyledLoader, StyledToggle } from "./styled";
var UIToggle = /** @class */ (function (_super) {
    __extends(UIToggle, _super);
    function UIToggle(props) {
        var _this = _super.call(this, props) || this;
        _this.getLoadingIcons = function () {
            var loaded = _this.state.loaded;
            var _a = _this.props, loader = _a.loader, checked = _a.checked, icons = _a.icons;
            if (loaded) {
                // user default toggle icons
                return icons;
            }
            if (checked) {
                return { checked: loader, unchecked: null };
            }
            return { unchecked: loader, checked: null };
        };
        _this.handleClick = function (event) {
            var loaded = _this.state.loaded;
            var onClick = _this.props.onClick;
            if (loaded) {
                var checked_1 = event.target.checked;
                _this.setState({ checked: checked_1 }, function () {
                    onClick(checked_1);
                });
            }
            else {
                _this.setState({ checked: _this.state.checked });
            }
        };
        // create state for loader
        _this.state = {
            checked: props.checked
        };
        return _this;
    }
    UIToggle.prototype.componentDidMount = function () {
        this.loader = new Load(this);
    };
    UIToggle.prototype.componentWillUnmount = function () {
        if (this.loader)
            this.loader.destroy();
    };
    UIToggle.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (this.loader)
            this.loader.update(nextProps);
        if (nextProps.checked !== this.state.checked) {
            this.setState({ checked: nextProps.checked });
        }
    };
    UIToggle.prototype.render = function () {
        var _a = this.props, onClick = _a.onClick, label = _a.label, hint = _a.hint, disabled = _a.disabled, props = __rest(_a, ["onClick", "label", "hint", "disabled"]);
        var _b = this.state, checked = _b.checked, loaded = _b.loaded;
        var id = newId("toggle", this.props);
        var shouldDisable = !loaded || disabled;
        var toggleColor = props.toggleColor || perkbox.blue;
        return (React.createElement(React.Fragment, null,
            React.createElement(Flex, { alignItems: "center" },
                label && (React.createElement(StyledLabel, { bold: true, htmlFor: id }, label)),
                React.createElement(StyledToggle, __assign({}, props, { togglecolor: toggleColor, id: id, disabled: shouldDisable, icons: this.getLoadingIcons(), checked: checked, onClick: this.handleClick }))),
            hint && (React.createElement(React.Fragment, null,
                React.createElement(HintText, { id: newId("copy-hint", id), small: true }, hint)))));
    };
    UIToggle.defaultProps = {
        loader: React.createElement(StyledLoader, { color: "white" }),
        checked: false,
        disabled: false,
        // default is undefined so we default to react-toggle icons. Use false to hide
        icons: undefined
    };
    return UIToggle;
}(Component));
export default UIToggle;
